import { AddOnlineItemController } from "./add-item-controller";
import { NewOnlineItemDialogController } from "./new-item-dialog.controller";
import { ImportOnlineDialogController } from "./import-online-dialog.controller";
import { ImportOnlineMediaService } from "./import-online-media.service";
import { ImportOnlinePasserelleService } from "./import-online-passerelle.service";
import { ImportOnlineSaleItemsService } from "./import-online-sale-items.service";

angular
    .module("thor.online-containers.edit.add-item.component", [])
    .component("addOnlineItem", {
        bindings: {
            container: "<",
            isMaxItemsReached: "<"
        },
        controller: AddOnlineItemController,
        controllerAs: "addOnlineItemCtrl"
    })
    .service("importOnlineMedia", ImportOnlineMediaService)
    .service("importOnlinePasserelle", ImportOnlinePasserelleService)
    .service("importOnlineSaleItems", ImportOnlineSaleItemsService)
    .controller("NewOnlineItemDialogController", NewOnlineItemDialogController)
    .controller("ImportOnlineDialogController", ImportOnlineDialogController);
